/**
 * このゲームの識別子。**Phaser を引かない軽いモジュール**にしておく
 * （`registry.ts` と `platform/` から参照されるので、ここが重いと初期バンドルが太る）。
 *
 * 🔴 **この文字列は後から変更できない**。D1 の `game_key` / `src/games/<key>/` /
 *   `src/locales/<lang>/<key>.json` / `public/assets/<key>/` / localStorage の `<key>.*`
 *   が全部これと同じでなければならない（CLAUDE.md の規則1）。
 *
 * 名前はロゴ（`さめがめ / SAMEGAME`）に合わせた。カラーソートと同じ判断で、
 *   ⚠️ キーだけ別名にすると画面と台帳の名前がずれる。
 */
export const GAME_KEY = 'samegame';
